var _jsxFileName = "/src/main/react/src/main/app/components/images/ImageCard.js";
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { GridListTile, GridListTileBar, Tooltip, Fade } from '@material-ui/core';
import { ErrorTwoTone as Error } from '@material-ui/icons';
import { Controller, animated } from 'react-spring';
import { Dialog } from '../common';
import Util from '../../util/Util';
import { ENTITY_SELECTED, HOMEPAGE } from "../Routes";
import { ASPECT_RATIO, ASPECT_RATIO_TO_PADDING_TOP, Q_STRING } from "../domain/constants";
import { isNotABlankString } from "../../util/StringUtil";
const styles = theme => ({
  media: {
    width: 'auto',
    height: '200px'
  },
  image: {
    width: '100%',
    height: 'auto'
  },
  card: {},
  imgBadge: {
    position: 'absolute',
    top: '5px',
    right: '5px',
    color: '#ffeb3b',
    margin: theme.spacing(2)
  },
  lightTooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11
  },
  maintainAspectRatio: {
    width: '100%',
    height: 'auto',
    position: 'relative'
  }
});
class ImageCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imgSrc: props.imageURL,
      displayTitle: props.displayTitle,
      adiId: props.adiId != null ? props.adiId : '',
      // ADI id to link to entity page
      allAdiIds: props.allAdiIds != null ? props.allAdiIds : [],
      // ADI ids to display on entity page
      merlinId: props.merlinId != null ? props.merlinId : '',
      // merlinId to link to entity/display on entity
      merlinResourceType: props.merlinResourceType,
      title: props.title != null ? props.title : '',
      // title to display/search in case of missing IDs
      canLinkToEntity: props.canLinkToEntity != null ? props.canLinkToEntity : true,
      hasAuditPendingImages: props.hasAuditPendingImages != null ? props.hasAuditPendingImages : false,
      hasPublishPendingImages: props.hasPublishPendingImages != null ? props.hasPublishPendingImages : false,
      hasPublishFailedImages: props.hasPublishFailedImages != null ? props.hasPublishFailedImages : false,
      hasPublishFailedAssociations: props.hasPublishFailedAssociations != null ? props.hasPublishFailedAssociations : false,
      hasPendingAssociations: props.hasPendingAssociations != null ? props.hasPendingAssociations : false,
      orphan: props.orphan === true,
      normalized: props.normalized != null ? props.normalized : false,
      // whether image should be cropped for display purposes
      type: props.type,
      ratio: props.ratio != null ? props.ratio : ASPECT_RATIO.THREE_BY_FOUR,
      subtitle: props.subtitle != null ? props.subtitle : ''
    };

    // This is what actually determines the shape of the image card. If you don't add the ratio
    // to this map, it will not display in the aspect ratio you expect
    if (ASPECT_RATIO_TO_PADDING_TOP.hasOwnProperty(this.state.ratio)) {
      this.displayAspectRatio = ASPECT_RATIO_TO_PADDING_TOP[this.state.ratio];
    } else {
      this.displayAspectRatio = ASPECT_RATIO_TO_PADDING_TOP[ASPECT_RATIO.THREE_BY_FOUR];
    }
    this.routeEntity = this.routeEntity.bind(this);
    this.animations = new Controller({
      opacity: 0
    });
    this.dialog = null;
    this.setDialogRef = element => {
      this.dialog = element;
    };
  }
  routeEntity() {
    let path = HOMEPAGE;
    let search = '';
    if (this.state.canLinkToEntity === true) {
      path = ENTITY_SELECTED;
      search = "?".concat(Q_STRING.ADI_ID, "=") + this.state.adiId + "&".concat(Q_STRING.MERLIN_ID, "=") + this.state.merlinId + "&".concat(Q_STRING.TITLE, "=") + encodeURIComponent(this.state.title);
      this.props.history.push({
        pathname: path,
        search: search,
        state: {
          allAdiIds: this.state.allAdiIds
        }
      });
    } else {
      Util.createDialog('Unable to Link To Entity Page', 'This image is not associated to an ADI id or a merlin ID. An entity page is not available', this.dialog);
    }
  }
  render() {
    const classes = this.props.classes;
    const _this$state = this.state,
      imgSrc = _this$state.imgSrc,
      hasAuditPendingImages = _this$state.hasAuditPendingImages,
      hasPublishPendingImages = _this$state.hasPublishPendingImages,
      hasPendingAssociations = _this$state.hasPendingAssociations,
      orphan = _this$state.orphan,
      merlinResourceType = _this$state.merlinResourceType,
      normalized = _this$state.normalized,
      hasPublishFailedImages = _this$state.hasPublishFailedImages,
      hasPublishFailedAssociations = _this$state.hasPublishFailedAssociations,
      type = _this$state.type;
    const title = this.state.title != null ? this.state.title + (this.state.subtitle !== '' ? ": " + this.state.subtitle : '') : this.state.displayTitle;
    const props = this.animations.update({
      opacity: 1
    });
    return /*#__PURE__*/React.createElement(Tooltip, {
      title: title,
      TransitionComponent: Fade,
      classes: {
        tooltip: classes.lightTooltip
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 114,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(GridListTile, {
      onClick: () => this.routeEntity(),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 115,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(animated.div, {
      className: classes.maintainAspectRatio,
      style: {
        backgroundImage: "url(".concat(imgSrc, ")"),
        backgroundPosition: 'center',
        backgroundSize: "".concat(normalized === true ? 'cover' : 'contain'),
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#fafafa',
        // subtle off-white coloring
        paddingTop: this.displayAspectRatio,
        props
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 116,
        columnNumber: 21
      }
    }), (title != null && title !== '' || type != null && type !== '') && /*#__PURE__*/React.createElement(GridListTileBar, {
      title: title,
      subtitle: type,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 127,
        columnNumber: 21
      }
    }), (hasAuditPendingImages === true || hasPendingAssociations === true || orphan === true || merlinResourceType != null || hasPublishFailedImages === true || hasPublishFailedAssociations === true) && ImageCard.getAlertIcon(hasAuditPendingImages, hasPublishPendingImages, hasPendingAssociations, hasPublishFailedImages, hasPublishFailedAssociations, orphan, merlinResourceType, classes), /*#__PURE__*/React.createElement(Dialog, {
      ref: this.setDialogRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 133,
        columnNumber: 21
      }
    })));
  }
  static getAlertIcon(hasAuditPendingImages, hasPublishPendingImages, hasPendingAssociations, hasPublishFailedImages, hasPublishFailedAssociations, orphan, merlinResourceType, classes) {
    let children = [];
    if (hasAuditPendingImages === true) {
      children.push(React.createElement('li', null, 'This entity has images that are pending audit'));
    }
    if (hasPublishPendingImages === true) {
      children.push(React.createElement('li', null, 'This entity has images that are pending publish'));
    }
    if (hasPendingAssociations === true) {
      children.push(React.createElement('li', null, 'This entity has associations that are pending audit'));
    }
    if (hasPublishFailedImages === true) {
      let message = orphan === true ? 'This image has failed to publish' : 'This entity has images that have failed to publish';
      children.push(React.createElement('li', null, message));
    }
    if (hasPublishFailedAssociations === true) {
      children.push(React.createElement('li', null, 'This entity has associations that have failed to publish'));
    }
    if (orphan === true) {
      children.push(React.createElement('li', null, 'This image is linked to an ADI id that does not yet exist in merlin'));
    }
    if (merlinResourceType != null && typeof merlinResourceType === "string" && "temporary" === merlinResourceType.toLowerCase()) {
      children.push(React.createElement('li', null, 'This program has a merlin resource type of Temporary'));
    }
    const titleNode = React.createElement('ul', {
      style: {
        listStyleType: 'none',
        paddingLeft: 0,
        paddingTop: 0,
        paddingBottom: 0
      }
    }, children);
    if (children.length > 0) {
      return /*#__PURE__*/React.createElement(Tooltip, {
        title: titleNode,
        TransitionComponent: Fade,
        classes: {
          tooltip: classes.lightTooltip
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 180,
          columnNumber: 17
        }
      }, /*#__PURE__*/React.createElement(Error, {
        fontSize: 'large',
        className: classes.imgBadge,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 181,
          columnNumber: 21
        }
      }));
    } else {
      return '';
    }
  }
}
export default withStyles(styles)(withRouter(ImageCard));